import { render, staticRenderFns } from "./c-cart.vue?vue&type=template&id=60ce2cbc&scoped=true&"
import script from "./c-cart.vue?vue&type=script&lang=js&"
export * from "./c-cart.vue?vue&type=script&lang=js&"
import style0 from "./c-cart.vue?vue&type=style&index=0&id=60ce2cbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce2cbc",
  null
  
)

export default component.exports